import { ShipmentState } from './shipment.state';
import { Action, createReducer } from '@ngrx/store';

const initialState: ShipmentState = {
    submissionIds: [],
    voidIds: []
};

const reducer = createReducer(
    initialState
);

export function shipmentReducer(state: ShipmentState | undefined, action: Action): any {
    return reducer(state, action);
}
